import { render, staticRenderFns } from "@/manager/client/views/clientEdit/clientEdit.pug?vue&type=template&id=63c9a202&scoped=true&lang=pug&external"
import script from "./clientList.view.vue?vue&type=script&lang=ts"
export * from "./clientList.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/client/views/clientEdit/clientEdit.scss?vue&type=style&index=0&id=63c9a202&prod&scoped=true&lang=scss&external"
import style1 from "@/manager/convocation/views/convocationDetail/noteItem/noteItem.scss?vue&type=style&index=1&id=63c9a202&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9a202",
  null
  
)

export default component.exports